export default {
  'primary-newsletter-tittle': 'Supercharge Your DevRel Team',
  'primary-newsletter-byline': '',
  'primary-newsletter-button-cta-label': 'Get Exclusive DevRel Insights',
}
